module.exports = __webpack_public_path__ + "static/media/gmobgimg.b1499707.jpg";